import React from 'react';
import Datas from '../../../data/about-us/about-us2.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../../styles/aboutUsTwo.js";
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../LanguageSelector';

const AboutUsTwo = () => {
    const { t } = useTranslation();

    return (
        <Styles>
            {/* About Us 2 */}
            <section className="about-us2">
                <Container>
                    <Row>
                        <Col md="6" style={{ minHeight: '530px' }}>
                            <div className="about-content">
                                <h4 className="about-title">{t('welcome_message')}</h4>
                                <p className="about-para">{t('select_language')}</p>

                                {
                                    Datas.dataList.map((data, i) => (
                                        <div className="cta-box d-flex" key={i}>
                                            <div className="cta-icon text-center">
                                                <i className="las la-thumbs-up"></i>
                                            </div>
                                            <div className="cta-content">
                                                <h6>{t(`about2.list.${i}.title`)}</h6>
                                                <p>{t(`about2.list.${i}.subtitle`)}</p>
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </Col>
                        <Col md="6">
                            <div className="about-image">
                                <img src={process.env.PUBLIC_URL + `/assets/images/${Datas.aboutImageOne}`} className="main-img1" alt="" />
                                <img src={process.env.PUBLIC_URL + `/assets/images/${Datas.aboutImageTwo}`} className="main-img2" alt="" />
                                <p className="exp-box"><span>{Datas.experianceYear}<i className="las la-plus"></i></span> {t('years_experience')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default AboutUsTwo